<template>
  <div class="modal twentyk_camp" :style="{'top': `${topPos}px`}" :class="{'is-active':show}">
    <div class="modal-background"></div>
    <div class="modal-content">
      <button class="modal-close is-large" aria-label="close" @click="hideModal"></button>
      <p class="image is-4by3">
        <a href="/write-a-review?utm_source=b2c+website+pop+up+modal&utm_medium=banner&utm_campaign=20K+Write+A+review+&utm_term=pop+up+modal+b2c">
          <img :src="`${popupImgPath}.webp?1`"
               :srcset="`${popupImgPath}@2x.webp?1 1.5x,
               ${popupImgPath}@2x.webp?1 2x,
               ${popupImgPath}@3x.webp?1   3x`"/>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import {misc} from '@/mixins'

export default {
  name: 'TwentyKCampaign',
  mixins: [misc],
  data () {
    return {
      show: false,
      topPos: 0,
      hideOnRoutes: ['Privacy Policy', 'Legal']
    }
  },
  computed: {
    popupImgName () {
      return `20k_campaign_${this.deviceType}`
    },
    popupImgPath () {
      return `/static/img/events/20k_campaign/popup/${this.popupImgName}`
    }
  },
  mounted () {
    this.topPos = document.getElementById('default-header').getBoundingClientRect().height

    if (!this.hideOnRoutes.includes(this.$route.name)) {
      let twentykCamp = localStorage.getItem("twentykCamp")
      if (!twentykCamp) { //Modal not shown today
        this.showModal()
      } else { //Modal was shown
        const now = Date.now()
        if (twentykCamp - now <= 0) { //New day started
          this.showModal()
        }
      }
    }
  },
  methods: {
    showModal () {
      this.show = true

      const end = new Date();
      end.setHours(23, 59, 59, 999)
      localStorage.setItem("twentykCamp", end.getTime())
    },
    hideModal () {
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.twentyk_camp {
  @include mobile {
    justify-content: unset;
    padding-top: 9px;
  }

  .modal-content {
    @include mobile {
      width: 300px;
      height: 549px;

      .image {
        position: static;
      }
    }

    .modal-close {
      position: absolute;
      z-index: 9;
      right: 29px;
      top: 8px;
      $xDimension: 39px;
      height: $xDimension;
      max-height: $xDimension;
      min-height: $xDimension;
      max-width: $xDimension;
      min-width: $xDimension;
      width: $xDimension;

      @include tablet {
        right: 54px;
        top: 3px;
      }

      @include mobile {
        right: -1px;
        top: 2px;
      }

      @include not-desktop {
        $xDimension: 27px;
        height: $xDimension;
        max-height: $xDimension;
        min-height: $xDimension;
        max-width: $xDimension;
        min-width: $xDimension;
        width: $xDimension;
      }

      &::before, &::after {
        background-color: #000;
      }
    }

    img {
      max-width: 600px;
      max-height: 400px;
      margin: 0 auto;

      @include tablet {
        max-width: 540px;
      }

      @include mobile {
        max-height: 549px;
        height: 549px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TwentyKCampaign.vue